const maritalStatus = [
  {
    label: 'Casado',
    value: 1,
  },
  {
    label: 'Desquitado',
    value: 2,
  },
  {
    label: 'Divorciado',
    value: 3,
  },
  {
    label: 'Separado',
    value: 4,
  },
  {
    label: 'Solteiro',
    value: 5,
  },
  {
    label: 'Viúvo',
    value: 6,
  },
  {
    label: 'União estável',
    value: 7,
  },
];

export default maritalStatus;
